module.exports = __webpack_public_path__ + "src/assets/img/404cta--dsk.321cff77.png";